import FormattedMessageWithObjectTypeName from 'automation-ui-i18n/FormattedMessageWithObjectTypeName';
import * as PropertyValueTypes from 'automation-ui-flow-core/fields/PropertyValueTypes';
import { getPropertyDateDelayFormatOptions, getStaticDateDelayFormatOptions } from 'automation-ui-action-features/actions/delay-until-date/utils/dateDelayFormatOptions';
import { TimeZoneStrategyType } from 'automation-ui-flow-core/fields/time/TimeZoneStrategy';
import { jsx as _jsx } from "react/jsx-runtime";
export default function DelayUntilDateActionExplainer({
  action,
  flowObjectTypeId
}) {
  const metadata = action.metadata;
  const date = metadata.getDate();
  const timeOfDay = metadata.getTimeOfDay();
  if (date.getType() === PropertyValueTypes.OBJECT_PROPERTY) {
    const delta = metadata.getTimeDelta().getDelta();
    let messageKey;
    let timeOfDayMessageKey = '';
    if (!timeOfDay) {
      timeOfDayMessageKey = '-datetime';
    }
    if (delta < 0) {
      messageKey = `automation-ui-action-features.action-features.delay-until-date.explainer.before-date-property${timeOfDayMessageKey}_cob`;
    } else if (delta > 0) {
      messageKey = `automation-ui-action-features.action-features.delay-until-date.explainer.after-date-property${timeOfDayMessageKey}_cob`;
    } else {
      messageKey = `automation-ui-action-features.action-features.delay-until-date.explainer.on-date-property${timeOfDayMessageKey}_cob`;
    }
    return /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
      baseLangKey: messageKey,
      options: getPropertyDateDelayFormatOptions(metadata, flowObjectTypeId),
      objectTypeId: flowObjectTypeId,
      elements: {
        Bold: 'strong'
      }
    });
  } else {
    const timeZoneStrategy = metadata.getTimeZoneStrategy();
    const baseLangKey = (timeZoneStrategy === null || timeZoneStrategy === void 0 ? void 0 : timeZoneStrategy.type) === TimeZoneStrategyType.ENROLLED_OBJECT ? 'automation-ui-action-features.action-features.delay-until-date.explainer.on-date-time-in-object-timezone_cob' : 'automation-ui-action-features.action-features.delay-until-date.explainer.on-date-time_cob';
    return /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
      baseLangKey: baseLangKey,
      options: getStaticDateDelayFormatOptions(metadata),
      objectTypeId: flowObjectTypeId,
      elements: {
        Bold: 'strong'
      }
    });
  }
}